import React, { useCallback } from 'react'
import styled from 'styled-components/macro'
import footerLogo from 'assets/Name - White Transparent.svg'

const FooterWrapper = styled.footer`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: var(--footer-height);
  min-height: var(--footer-height);
  padding: 0 24px;
  background: #f9fafb;
  border-radius: 0 0 8px 8px;
`

const FooterContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

const FooterLinks = styled.div`
  display: flex;
  align-items: center;
`

const FooterButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 8px 12px;
  border: none;
  background: transparent;
  color: var(--nav-bg-primary);
  font-size: 14px;
  font-weight: 300;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  transition: background 0.15s ease-in-out;
  border-radius: 4px;

  &:hover {
    background: rgba(6, 81, 47, 0.08);
  }

  &:active {
    background: rgba(6, 81, 47, 0.12);
  }
`

const FooterLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 8px 12px;
  color: var(--nav-bg-primary);
  font-size: 14px;
  font-weight: 300;
  font-family: 'Inter', sans-serif;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.15s ease-in-out;
  border-radius: 4px;

  &:hover {
    background: rgba(6, 81, 47, 0.08);
    color: var(--nav-bg-primary);
    text-decoration: none;
  }

  &:active {
    background: rgba(6, 81, 47, 0.12);
  }
`

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 10px 0;
`

const FooterLogo = styled.img`
  height: 24px;
  width: auto;
  filter: brightness(0) saturate(100%) invert(22%) sepia(76%) saturate(1219%)
    hue-rotate(109deg) brightness(95%) contrast(84%);
`

interface NewFooterProps {
  className?: string
}

export const NewFooter: React.FC<NewFooterProps> = ({ className }) => {
  const supportEmail = 'support@firstbite.io'

  const handleContactClick = useCallback(() => {
    window.open(`mailto:${supportEmail}`)
  }, [])

  return (
    <FooterWrapper className={className}>
      <FooterContent>
        <FooterLinks>
          <FooterLink href="/privacy-policy">Privacy Policy</FooterLink>
          <FooterLink href="/terms-of-use">Terms of Use</FooterLink>
          <FooterButton onClick={handleContactClick}>Contact Us</FooterButton>
        </FooterLinks>
        <LogoContainer>
          <FooterLogo src={footerLogo} alt="First Bite" />
        </LogoContainer>
      </FooterContent>
    </FooterWrapper>
  )
}
